import {ReactNode, RefObject} from "react";
import {Grid2, SxProps, Theme} from "@mui/material";

export type LayoutItemProps = {
    children: ReactNode;
    grow?: boolean;
    body?: boolean;
    sx?: SxProps<Theme>;
    padding?: number;
    scrollRef?: RefObject<HTMLDivElement | null>;
};

export const LayoutItem = ({ scrollRef, sx, grow, padding, body, children }: LayoutItemProps) => (
    <Grid2
        ref={scrollRef}
        sx={{ height: body ? "100%" : undefined, overflow: body ? "auto" : undefined, ...sx }}
        flexGrow={grow ? 1 : undefined}
        padding={padding}
    >
        {children}
    </Grid2>
);

export type LayoutProps = {
    root?: boolean;
    children: ReactNode;
    sx?: SxProps<Theme>;
};

// Browsers without dvh support keep 100vh; the others use the visible viewport height.
const rootHeight = {
    height: "100vh",
    "@supports (height: 100dvh)": { height: "100dvh" }
} as const;

export const Layout = ({ root, sx, children }: LayoutProps) => (
        <Grid2
            container
            direction="column"
            flexWrap="nowrap"
            alignItems="stretch"
            height={root ? undefined : "100%"}
            sx={[root ? rootHeight : false, ...(Array.isArray(sx) ? sx : [sx])]}
        >
            {children}
        </Grid2>
    );
